export const comics = [
  {
    id: 1,
    slug: 'wode-nvshen-daren',
    title: '我的女神大人',
    author: '李智慧',
    category: '恋爱',
    categorySlug: 'lianai',
    rating: 9.6,
    ratingCount: 28430,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20in%20soft%20warm%20lighting%2C%20anime%20style%20art%2C%20clean%20simple%20background%20with%20cherry%20blossom%20petals%2C%20elegant%20character%20design%2C%20soft%20pink%20and%20warm%20tones%2C%20professional%20digital%20illustration%20quality%2C%20vertical%20poster%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '普通上班族林月意外邂逅了神秘女神韩雅，两人的相遇揭开了一段跨越命运的浪漫爱情故事。当平凡遇上非凡，当现实碰撞奇幻，一段令人心动的姐弟恋就此展开。',
    chapters: 87,
    status: '连载中',
    updateTime: '2026-07-03',
    tags: ['恋爱', '奇幻', '姐弟恋', '都市'],
    views: 1286000,
  },
  {
    id: 2,
    slug: 'jianmo-zhiwang',
    title: '剑魔之王',
    author: '金泰亨',
    category: '动作',
    categorySlug: 'dongzuo',
    rating: 9.4,
    ratingCount: 35200,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20powerful%20warrior%20wielding%20a%20massive%20sword%20in%20Korean%20manhwa%20style%2C%20dynamic%20action%20pose%2C%20dark%20fantasy%20atmosphere%2C%20epic%20battle%20scene%20background%20with%20flames%2C%20detailed%20armor%20design%2C%20intense%20expression%2C%20professional%20digital%20art%2C%20warm%20orange%20and%20crimson%20tones%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '被世人唾弃的弃剑少年，意外觉醒了远古剑魔的力量。从此踏上复仇之路，以手中之剑劈开命运枷锁，成为传说的剑魔之王。酣畅淋漓的战斗场面，让人热血沸腾。',
    chapters: 124,
    status: '连载中',
    updateTime: '2026-07-04',
    tags: ['动作', '奇幻', '复仇', '成长'],
    views: 2150000,
  },
  {
    id: 3,
    slug: 'mifa-de-mili',
    title: '密发的秘密',
    author: '朴秀妍',
    category: '悬疑',
    categorySlug: 'xuanyi',
    rating: 9.7,
    ratingCount: 18900,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20illustration%20with%20a%20woman%20looking%20back%20over%20her%20shoulder%2C%20dark%20moody%20atmosphere%2C%20suspenseful%20thriller%20vibe%2C%20rainy%20night%20city%20background%2C%20noir%20style%2C%20mysterious%20expression%2C%20professional%20digital%20art%2C%20deep%20shadows%20and%20warm%20highlights%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '小镇上接连发生离奇失踪案，记者金智恩深入调查，却发现每个失踪者都曾去过同一家理发店。一把剪刀，一个秘密，一个令人窒息的真相即将浮出水面。',
    chapters: 56,
    status: '连载中',
    updateTime: '2026-07-02',
    tags: ['悬疑', '惊悚', '推理', '都市'],
    views: 965000,
  },
  {
    id: 4,
    slug: 'xingkong-xia-de-yueding',
    title: '星空下的约定',
    author: '郑雨盛',
    category: '校园',
    categorySlug: 'xiaoyuan',
    rating: 9.3,
    ratingCount: 22300,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20manhwa%20school%20romance%20illustration%2C%20two%20teenagers%20under%20a%20starry%20night%20sky%2C%20school%20uniform%2C%20gentle%20warm%20lighting%2C%20nostalgic%20atmosphere%2C%20clean%20background%20with%20stars%2C%20youthful%20and%20tender%20mood%2C%20professional%20digital%20art%2C%20soft%20blue%20and%20warm%20tone%20accents%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '高中最后一年，学霸朴智勋和转学生林小婉在天文台相遇。星空为证，两人许下了关于未来的约定。青春的悸动，梦想的追逐，这是一部温暖治愈的校园恋歌。',
    chapters: 68,
    status: '已完结',
    updateTime: '2026-06-15',
    tags: ['校园', '恋爱', '青春', '治愈'],
    views: 1560000,
  },
  {
    id: 5,
    slug: 'huigui-zhe-de-ni',
    title: '回归者的逆袭',
    author: '韩东旭',
    category: '穿越',
    categorySlug: 'chuanyue',
    rating: 9.5,
    ratingCount: 31200,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20illustration%20of%20a%20hero%20returning%20through%20time%2C%20dramatic%20lighting%2C%20magical%20portal%20effect%2C%20medieval%20fantasy%20setting%2C%20determined%20expression%2C%20epic%20scale%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20professional%20digital%20illustration%2C%20vertical%20poster%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '被队友背叛惨死的大法师韩逸，带着前世记忆重生回到十年前。这一次，他不会再信任任何人，誓要改写命运，让所有背叛者付出代价。',
    chapters: 92,
    status: '连载中',
    updateTime: '2026-07-03',
    tags: ['穿越', '奇幻', '复仇', '重生'],
    views: 1890000,
  },
  {
    id: 6,
    slug: 'tianmi-de-xianjing',
    title: '甜蜜的陷阱',
    author: '崔美英',
    category: '恋爱',
    categorySlug: 'lianai',
    rating: 9.2,
    ratingCount: 15200,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20illustration%20of%20a%20couple%20in%20a%20cafe%2C%20warm%20cozy%20atmosphere%2C%20steaming%20coffee%2C%20soft%20sunlight%20through%20window%2C%20elegant%20character%20design%2C%20sweet%20romantic%20mood%2C%20professional%20digital%20art%2C%20warm%20amber%20tones%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '甜品师苏糖遇见了美食评论家姜赫，两人的每一次相遇都像精心调制的甜点。但当爱情来袭，她分不清这是一场甜蜜的邂逅还是精心设计的陷阱。',
    chapters: 45,
    status: '连载中',
    updateTime: '2026-07-01',
    tags: ['恋爱', '美食', '都市', '喜剧'],
    views: 732000,
  },
  {
    id: 7,
    slug: 'heian-shendian',
    title: '黑暗神殿',
    author: '金俊秀',
    category: '奇幻',
    categorySlug: 'qihuan',
    rating: 9.8,
    ratingCount: 45600,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20illustration%20of%20a%20mysterious%20ancient%20temple%2C%20gothic%20architecture%2C%20magical%20glowing%20runes%2C%20a%20lone%20adventurer%20at%20the%20entrance%2C%20epic%20scale%2C%20dramatic%20lighting%20from%20torches%2C%20professional%20digital%20art%2C%20warm%20firelight%20against%20darkness%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '在人类与魔族共存的艾泽大陆，一座被封印千年的黑暗神殿突然苏醒。少年祭司艾伦意外获得神殿传承，却发现神殿之下隐藏着足以毁灭世界的秘密。',
    chapters: 156,
    status: '连载中',
    updateTime: '2026-07-04',
    tags: ['奇幻', '冒险', '史诗', '魔法'],
    views: 3280000,
  },
  {
    id: 8,
    slug: 'xingguang-bu-ji-ni',
    title: '星光不及你',
    author: '尹智秀',
    category: '耽美',
    categorySlug: 'danmei',
    rating: 9.1,
    ratingCount: 12800,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20BL%20illustration%2C%20two%20handsome%20young%20men%20in%20tender%20moment%2C%20soft%20evening%20light%2C%20elegant%20atmosphere%2C%20star-lit%20sky%20background%2C%20delicate%20emotional%20expression%2C%20professional%20digital%20art%2C%20warm%20and%20gentle%20color%20palette%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '当红偶像团体成员边伯贤与新人演员都暻秀因一档综艺节目结缘。镜头前的默契配合，镜头后的心照不宣，星光再耀眼，也不及你眼中的温柔。',
    chapters: 38,
    status: '连载中',
    updateTime: '2026-06-30',
    tags: ['耽美', '娱乐圈', '治愈', '慢热'],
    views: 645000,
  },
  {
    id: 9,
    slug: 'xueyu-fuchou-ji',
    title: '血域复仇记',
    author: '朴志勋',
    category: '动作',
    categorySlug: 'dongzuo',
    rating: 9.4,
    ratingCount: 27800,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gritty%20Korean%20manhwa%20revenge%20action%20illustration%2C%20a%20lone%20fighter%20in%20urban%20night%20setting%2C%20rain-slicked%20streets%2C%20neon%20signs%2C%20intense%20fighting%20stance%2C%20dark%20noir%20atmosphere%2C%20professional%20digital%20art%2C%20contrasting%20warm%20neon%20and%20dark%20shadows%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '退役特种兵韩哲的家人被黑帮残忍杀害，法律无法伸张正义，他选择用自己的方式复仇。血债血偿，这是一场没有退路的战争。',
    chapters: 73,
    status: '已完结',
    updateTime: '2026-05-20',
    tags: ['动作', '复仇', '都市', '硬汉'],
    views: 1720000,
  },
  {
    id: 10,
    slug: 'diyou-modaisheng',
    title: '第五魔代生',
    author: '李智勋',
    category: '奇幻',
    categorySlug: 'qihuan',
    rating: 9.6,
    ratingCount: 38900,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20dark%20fantasy%20illustration%2C%20a%20demon%20king%20with%20crimson%20eyes%20and%20dark%20robes%2C%20burning%20kingdom%20background%2C%20epic%20apocalyptic%20scene%2C%20magical%20energy%20effects%2C%20dramatic%20composition%2C%20professional%20digital%20art%2C%20warm%20fire%20and%20shadow%20contrast%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '每五百年，魔界会诞生一位新的魔王。在第五次魔王诞生之际，人类王国、精灵联盟和龙族三方势力蠢蠢欲动，一场改变世界格局的大战即将爆发。',
    chapters: 110,
    status: '连载中',
    updateTime: '2026-07-04',
    tags: ['奇幻', '战争', '史诗', '多势力'],
    views: 2560000,
  },
  {
    id: 11,
    slug: 'xiaoshi-de-shijian',
    title: '消失的时间',
    author: '宋慧乔',
    category: '悬疑',
    categorySlug: 'xuanyi',
    rating: 9.5,
    ratingCount: 16800,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20illustration%2C%20a%20woman%20holding%20a%20pocket%20watch%2C%20time%20distortion%20effects%2C%20surreal%20atmosphere%2C%20clock%20gears%20in%20background%2C%20mysterious%20and%20eerie%20mood%2C%20professional%20digital%20art%2C%20warm%20sepia%20and%20shadow%20tones%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '警探张瑞妍发现每个案发现场都有一只停摆的怀表，表针永远指向受害者死亡的时刻。随着调查深入，她发现自己也成为了这个时间游戏中的一枚棋子。',
    chapters: 42,
    status: '连载中',
    updateTime: '2026-06-28',
    tags: ['悬疑', '科幻', '推理', '都市'],
    views: 525000,
  },
  {
    id: 12,
    slug: 'guanjun-zhi-lu',
    title: '冠军之路',
    author: '安宰贤',
    category: '竞技',
    categorySlug: 'jingji',
    rating: 9.3,
    ratingCount: 21000,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20sports%20illustration%2C%20a%20young%20athlete%20on%20a%20race%20track%2C%20dynamic%20running%20pose%2C%20stadium%20lights%20background%2C%20inspirational%20atmosphere%2C%20sweat%20and%20determination%2C%20professional%20digital%20art%2C%20warm%20stadium%20lighting%2C%20vertical%20poster&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '天赋平平的田径少年刘承俊，凭借超乎常人的毅力和对跑步的热爱，一步步从校队跑到全国大赛。这是关于梦想、汗水和永不言弃的故事。',
    chapters: 51,
    status: '连载中',
    updateTime: '2026-07-02',
    tags: ['竞技', '体育', '励志', '青春'],
    views: 820000,
  },
];